import { Link } from 'react-router-dom';
import './ConsoleTopbar.css';

/** Console top bar: brand (links back to the chooser) + system status. */
export default function ConsoleTopbar() {
  return (
    <header className="om-topbar">
      <Link to="/app" className="om-brand" aria-label="Back to agent chooser">
        <span>OCULUSMIND</span>
        <span className="om-brand__sep">/</span>
        <span className="om-brand__sub">Agent Console</span>
      </Link>
      <div className="om-topbar__spacer" />
      <div className="om-sysstatus">
        <span className="om-sysstatus__dot" />
        SYSTEMS · ONLINE
      </div>
    </header>
  );
}
